import { mapGetters } from 'vuex';

const BaseIconMixin = {
  props: {
    service: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'getActorByRole',
      'getActorVars',
      'getActorByArgumentNameAndService',
    ]),
  },
  methods: {
    getVarsByActorsArgumentName(argument) {
      const actor = this.getActorByArgumentNameAndService(this.service.id, argument);
      if (actor) {
        return this.getActorVars(actor);
      }
      return [];
    },
    getVarsByActorsRole(role) {
      const actor = this.getActorByRole(this.service.id, role);
      if (actor) {
        return this.getActorVars(actor);
      }
      return null;
    },
    getVarsValue(argumentName) {
      const vars = this.getVarsByActorsArgumentName(argumentName);
      if (vars.length > 0) {
        return vars[0].value;
      }
      return null;
    },
  },
};

export default BaseIconMixin;
